export const Color = {
    primary: '#EF4444',
    white: '#FFF',
    black: '#000',
    grey: '#FEFEFE',
    darkgrey: 'grey',
    datatableFontColor: 'rgba(0, 0, 0, 0.6)',
    borderColor: '#CCCCCC'
};